import { render, staticRenderFns } from "./ProductHero.vue?vue&type=template&id=314ae62a&scoped=true&"
import script from "./ProductHero.vue?vue&type=script&lang=js&"
export * from "./ProductHero.vue?vue&type=script&lang=js&"
import style0 from "./ProductHero.vue?vue&type=style&index=0&id=314ae62a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ae62a",
  null
  
)

export default component.exports